import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../actions/userActions';

const LoginForm: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();

  const userLogin = useSelector((state: appState) => state.userLogin);
  const { loading, error } = userLogin;

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    dispatch(login(username, password));
  };

  return (
    <form onSubmit={submitHandler}>
      <h3>Log into your Account</h3>
      <div className='form-control'>
        <label htmlFor='username'>Username</label>
        <input
          type='text'
          id='username'
          placeholder='Username'
          required
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='password' className='right'>
          Password
        </label>
        <input
          type='password'
          id='password'
          placeholder='Password'
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      {loading && <p>Loading...</p>}
      {error && <p className='error'>{error}</p>}
      <button type='submit' className='login-btn'>
        Log In
      </button>
      <Link to={'/signup'} className='narrow-btn'>
        Register Account
      </Link>
    </form>
  );
};

export default LoginForm;
